import { RulesTable, QTable, QTableBody, QTableRow, QTableCell, QSearchBar } from '@kw/quokka-ui';
import { Box } from '@mui/material';
import { useState, useMemo } from 'react';
import { filterByQuery as filterBySearchQuery } from '../utils/filterHelper';
import { useLocalStorage } from '../../../../utils/useLocalStorage';
import { getEvidencesCallbackWithToken, removeDuplicateRuleSummaries } from '../utils/dopplerUtil';

export const LibrariesAndFrameworks = ({ ruleSummaries, analysisId }) => {
  const uniqueRuleSummaries = removeDuplicateRuleSummaries(ruleSummaries) || [];

  const [accessToken = ''] = useLocalStorage('accessToken', '');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredBySearchQuery, setFilteredBySearchQuery] = useState(uniqueRuleSummaries);

  const handleSearchQuery = e => {
    const query = e.target.value.toString();
    setSearchQuery(query);
  };

  const onSearch = value => {
    setSearchQuery(value);
    const filtered = filterBySearchQuery(uniqueRuleSummaries, value);
    setFilteredBySearchQuery(filtered);
  };

  const handleKeyPress = e => {
    if (e.charCode === 13) {
      onSearch(e.target.value.toString());
    }
  };

  const resetQuery = () => {
    setSearchQuery('');
    setFilteredBySearchQuery(uniqueRuleSummaries);
  };

  const onButtonSearch = () => {
    onSearch(searchQuery);
  };

  const librariesAndFrameworksTable = useMemo(() => {
    return (
      <RulesTable
        ruleSummaries={filteredBySearchQuery}
        uuid={analysisId}
        getEvidencesCallback={getEvidencesCallbackWithToken(accessToken)}
        instance="QScout"
      />
    );
  }, [filteredBySearchQuery, analysisId, accessToken]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100vh' }}>
      <QTable data-testid="library-and-frameworks-rule-summaries-table">
        <QTableBody>
          <QTableRow hoverDisabled>
            <QTableCell sx={{ padding: '0px' }}>
              <Box
                sx={{
                  display: 'flex',
                  padding: '16px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '8px',
                  alignSelf: 'stretch',
                }}
              >
                <QSearchBar
                  searchValue={searchQuery}
                  onChange={handleSearchQuery}
                  onRemove={resetQuery}
                  onKeyPress={handleKeyPress}
                  onButtonSearch={onButtonSearch}
                  placeholder="Search"
                />
              </Box>
            </QTableCell>
          </QTableRow>
        </QTableBody>
      </QTable>
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        {librariesAndFrameworksTable}
      </Box>
    </Box>
  );
};
